exports.components = {
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-landing-page-landing-page-tsx": () => import("./../../../src/pages/LandingPage/LandingPage.tsx" /* webpackChunkName: "component---src-pages-landing-page-landing-page-tsx" */),
  "component---src-pages-on-construction-tsx": () => import("./../../../src/pages/on-construction.tsx" /* webpackChunkName: "component---src-pages-on-construction-tsx" */)
}

